var map = {
	"./child-2.jpg": 44799,
	"./child-3.jpg": 85884,
	"./obesity-package.jpg": 39281,
	"./package-01.jpg": 97982,
	"./package-02.jpg": 28824,
	"./package-03-men-fertility-care.jpg": 28957,
	"./package-04-women-fertility-care.jpg": 35948,
	"./package-05.jpg": 64656,
	"./package-10.jpg": 97458,
	"./package-pcos.jpg": 4983,
	"./package-women-health.jpg": 49425,
	"./women-diabetic.jpg": 79638,
	"./women-quickscreening.jpg": 12254
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23143;